export const faqsInitialValues = {
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  location: '',
  updates: true,
  description: '',
};
